export default __webpack_public_path__ + "static/media/close.4dde7a6f.svg";